import MDBox from "components/MDBox";
import { draftColors } from "./draftDesignTokens";

type ExpandedWrapperProps = {
  children: React.ReactNode;
};

export default function ExpandedWrapper({ children }: ExpandedWrapperProps) {
  return (
    <MDBox
      sx={{
        backgroundColor: draftColors.surfaceMuted,
        p: "12px",
        borderBottom: `1px solid ${draftColors.border}`,
      }}
    >
      <MDBox display="flex" flexDirection="column" gap="4px">
        {children}
      </MDBox>
    </MDBox>
  );
}
